import { Api } from './api/axios-config';

export class DashboardService {
  private static api = Api();

  public static async getContagemBusiness(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/filtrar', {
        mes: mes,
        ano: ano,
      });
      return { count: response.data }
    } catch (e) {
      console.log(e)
    }
  }

  public static async getSumBusiness(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/sum', {
        mes: mes,
        ano: ano,
      });
      return response
    } catch (e) {
      console.log(e);
    }
  }

  public static async getCountGroup(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/countGroup', {
        mes: mes,
        ano: ano,
      });
      return response
    } catch (e) {
      console.error(e);
    }
  }

  public static async getFinished(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/getFinished', {
        mes: mes,
        ano: ano,
      });
      return response
    } catch (e) {
      console.error(e);
    }
  }
  
  public static async getPendentes(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/getPendentes', {
        mes: mes,
        ano: ano,
      });
      return response
    } catch (e) {
      console.error(e);
    }
  }
  public static async getSumByGroup(mes: number, ano: number) {
    try {
      const response = await this.api.post('dashboard/getSumByGroup', { mes: mes, ano: ano});
      return response
    } catch (e) {
      console.error(e);
    }
  }
}
